import script from "./FormSuggestion.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSuggestion.vue?vue&type=script&setup=true&lang=js"

import "./FormSuggestion.vue?vue&type=style&index=0&id=461696c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-461696c4"]])

export default __exports__